import styled from 'styled-components';

interface ContactsProps {
  userContactsLength: number;
}

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: inherit;

  @media (max-width: 960px) {
    text-align: center;
  }
`;

export const ContactsListContainer = styled.div<ContactsProps>`
  display: flex;
  flex-direction: column;
  max-width: inherit;
  border-radius: 16px;
  padding: ${({ userContactsLength }) =>
    userContactsLength > 5 ? '5px' : 'initial'};
  max-height: ${({ userContactsLength }) =>
    userContactsLength > 5 ? '400px' : 'initial'};
  overflow-y: ${({ userContactsLength }) =>
    userContactsLength > 5 ? 'scroll' : 'initial'};

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.primaryDark1};
  }

  @media (max-width: 960px) {
    padding: ${({ userContactsLength }) =>
      userContactsLength > 3 ? '5px' : 'initial'};
    max-height: ${({ userContactsLength }) =>
      userContactsLength > 3 ? '300px' : 'initial'};
    overflow-y: ${({ userContactsLength }) =>
      userContactsLength > 3 ? 'scroll' : 'initial'};
  }
`;

export const Button = styled.button<{ color: string; loading?: boolean }>`
  height: 40px;
  width: fit-content;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primaryDark1
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: 10px;
  margin: auto;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius) ? `${props.theme.borderRadius}px` : '5px'};
  font-size: 16px;
  font-weight: bold;

  &:disabled {
    cursor: not-allowed;
  }
`;
